import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PlansTable } from "./PlansTable";
import type { Plan } from "@/types/plan";

interface PlansTableWrapperProps {
  plans: Plan[];
  onEdit: (plan: Plan) => void;
}

export const PlansTableWrapper = ({ plans, onEdit }: PlansTableWrapperProps) => {
  return (
    <>
      <CardHeader>
        <CardTitle>Planos Cadastrados</CardTitle>
      </CardHeader>
      <CardContent>
        <PlansTable plans={plans} onEdit={onEdit} />
      </CardContent>
    </>
  );
};